import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AttemptPage } from './attempt';

@NgModule({
  declarations: [
    AttemptPage,
  ],
  imports: [
    IonicPageModule.forChild(AttemptPage),
  ],
})
export class AttemptPageModule {}



// WEBPACK FOOTER //
// ./src/pages/attempt/attempt.module.ts